// Components
require('./header/js/header');
require('./slider/js/slider');
require('./archive/js/slider');